export const roundVolume = (value) =>
  Number.isFinite(value) ? Math.round(value * 100) / 100 : null;

export const kg = (value) =>
  Number.isFinite(value) ? `${roundVolume(value)} Kg` : "—";

export const cylindersOf = (products) => {
  const seen = new Set();

  return (products || [])
    .filter((product) => Number.isFinite(product.volume) && product.volume > 0)
    .map((product) => ({
      productId: product.id,
      volume: roundVolume(product.volume),
      price: product.price,
      currency: product.currency,
      pricePerKg: product.pricePerKg,
      materials: product.containerMaterials || [],
    }))
    .sort((a, b) => a.volume - b.volume)
    .filter((cylinder) => {
      if (seen.has(cylinder.volume)) return false;
      seen.add(cylinder.volume);
      return true;
    });
};
